'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".StylelessButton-module_button__kaxON{background:none;border:none;cursor:pointer;padding:0}";
var styles = {"button":"StylelessButton-module_button__kaxON"};
styleInject["default"](css_248z, 'daf8d559-5e3b-412b-9a56-537557c65d61');

exports["default"] = styles;
